<template>
    <div>
        <div :style="tableLoaded ? 'padding: 1.25rem;' : ''" :class="showTableBarLoader ? 'disabled-custom-class' : ''" v-if="tableLoaded">
            <data-table
                :exportable="this.$store.getters.hasPermission(['project_company_price_list'], ['read'])"
                title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @rowClickDelete="onDeleteRow"
                @rowClickEdit="onEditRow"
                @changePage="changePage"
                @searchEvent="searchEvent"
                @orderByEvent="orderByEvent"
                @exportButtonClick="onExportButton"
            >
            </data-table>

            <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_company_price_list'], ['create'])">
                <i class="fa fa-plus-circle mr-1"></i> {{ addButtonTitle }}
            </b-btn>

            <span v-if="this.$store.getters.hasPermission(['project_company_price_list'], ['create', 'update'])">
                <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                    <span><i class="fa fa-upload mr-1"></i> {{ $t('general.subcontractors.subcontractors_price_list.import_button') }}</span>
                    <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                </label>
                <label v-else class="btn btn-primary mt-3 disabled">
                    <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                </label>
            </span>

            <price-list-modal
                ref="priceListModal"
                :priceListType="priceListType"
                @onLoadTable="onLoadTable"
            >
            </price-list-modal>

            <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
                {{ $t('messages.delete') }}
            </confirm-dialog>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';
import PriceListModal from '@/components/global/modals/PriceListModal.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
    name: 'price_list_table',
    components: {
        DataTable,
        notificationIcons,
        PriceListModal,
        ConfirmDialog
    },
    props: {
        priceListType: {
            type: String,
            required: true
        },
        columnData: {
            type: Array,
            required: true
        },
        addButtonTitle: {
            type: String,
            required: true
        },
    },
    data () {
        return {
            tableName: 'project_price_list',
            actionTitleDelete: '',
            actionTitle: '',
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            row: null,
            currentTableName: null,
            showTableBarLoader: false,
            getData: {
                rowData: [],
            },
        }
    },
    mounted () {
        switch (this.priceListType) {
            case 'part': 
                this.currentTableName = 'project_part_price_list';
            break;
            case 'weld':
                this.currentTableName = 'project_weld_price_list';
            break;
            case 'equipment':
                this.currentTableName = 'project_equipment_price_list';
            break;
            case 'painting':
                this.currentTableName = 'project_painting_price_list';
            break;
            case 'scaffolding':
                this.currentTableName = 'project_scaffolding_price_list';
            break;
            case 'insulation':
                this.currentTableName = 'project_insulation_price_list';
            break;
            case 'tie_in':
                this.currentTableName = 'project_tie_in_price_list';
            break;
            case 'custom':
                this.currentTableName = 'project_custom_price_list';
            break;
        }
        this.onLoadTable();
    },
    computed: {
        measure_units: {
			get: function () {
				let measure_units = this.$store.getters.getMeasureUnits;
				return measure_units;
			}
		},
        price_types: {
            get: function () {
                let price_types = this.$store.getters.getPriceTypes;
                return price_types;
            }
        },
    },
    watch: {
        measure_units: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
			}
		},
        price_types: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 6000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            this.showTableBarLoader = true;
            this.$emit('showSpinnerFunction', this.showTableBarLoader);
            let table_url = this.currentTableName + '?project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&company_id=' + this.$route.params.id2;

            http.route(table_url).get().then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    var data         = response.data;
                    data.forEach(field => {
                        if (typeof this.price_types[field.price_type] != 'undefined') {
                            field.price_typeV = this.price_types[field.price_type].name;
                        }
                        
                        if (typeof this.measure_units[field.measureunit] != 'undefined') {
                            field.measureunitV = this.measure_units[field.measureunit].name;
                        }

                        field.weld_key_value = null;
                        if (field.project_setting != null) {
                            field.weld_key_value = field.project_setting.value;
                        }

                        field.weld_material_value = null;
                        if (field.weld_material != null) {
                            field.weld_material_value = field.weld_material.value;
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;

                    this.showTableBarLoader = false;
                    this.$emit('showSpinnerFunction', this.showTableBarLoader);
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });

                    this.showTableBarLoader = false;
                    this.$emit('showSpinnerFunction', this.showTableBarLoader);
                }
            });
        },
        onAddRow () {
            this.$refs.priceListModal.onAddRow();
        },
        onEditRow (row) {
            this.$refs.priceListModal.onEditRow(row);
        },
        onDeleteRow (row, index) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.subcontractors.' + this.priceListType + '_price_list.title');
            this.row = row;
            this.warnMsg(Vue.i18n.translate('misc.price_list_pc_delete_warn'));
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.row = null;
                        this.onLoadTable();
                        this.successMsg(Vue.i18n.translate('general.subcontractors.' + this.priceListType + '_price_list.title') + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }

            this.$refs.deleteModal.hide();
        },
        onExportButton() {
            http.route(this.currentTableName + '?project_id=' + this.$route.params.id+'&company_id='+this.$route.params.id2).exportExcel({
                export: '1',
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, this.priceListType + '_price_list.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(Vue.i18n.translate('general.subcontractors.' + this.priceListType + '_price_list.title') + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);
            formData.append('company_id', this.$route.params.id2);
            formData.append('price_type', this.priceListType);

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route(this.tableName + '/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(Vue.i18n.translate('general.subcontractors.' + this.priceListType + '_price_list.title') + Vue.i18n.translate('messages.imported'));
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/project/subcontractors/price_list/price_list_table.vue